var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contractId)?_c('transactionHistory',{attrs:{"contractId":_vm.contractId}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }